import React from 'react';
import { TASK_COLOR, MARKER_OPACITY } from './types';
import type { TaskMarker } from './types';

interface Props {
  marker: TaskMarker;
  dark: boolean;
  onClick?: () => void;
  /** Batch-12: Marker-Farbe überschreiben (Verordnungen = blau). */
  color?: string;
}

/** Deadline-Marker (Verbindungslinie nach oben + Diamant) im UNTEREN Band (K5). */
export function TaskMarkerView({ marker, dark, onClick, color = TASK_COLOR }: Props) {
  return (
    <div
      title={marker.tooltip}
      role={onClick ? 'button' : undefined}
      onClick={onClick}
      style={{
        position: 'absolute', left: `${marker.left}%`, bottom: 6,
        transform: 'translateX(-50%)', zIndex: 3,
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        // Leicht transparent (alles außer Betreuungen), erledigte noch blasser.
        opacity: marker.done ? MARKER_OPACITY * 0.6 : MARKER_OPACITY,
      }}
    >
      <span style={{ width: 1, height: 12, background: color, opacity: 0.5 }} />
      <span style={{
        width: 12, height: 12, borderRadius: 3, background: color,
        transform: 'rotate(45deg)', border: `1.5px solid ${dark ? '#1c1c1c' : '#fff'}`,
        boxShadow: dark ? 'none' : '0 1px 3px rgba(16,24,40,0.3)',
        textDecoration: marker.done ? 'line-through' : 'none',
      }} />
    </div>
  );
}
